/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface OutputAnalyticsChannelHeatmapItem
 */
export interface OutputAnalyticsChannelHeatmapItem {
    /**
     * 
     * @type {string}
     * @memberof OutputAnalyticsChannelHeatmapItem
     */
    band: string;
    /**
     * 
     * @type {string}
     * @memberof OutputAnalyticsChannelHeatmapItem
     */
    channel: string;
    /**
     * 
     * @type {number}
     * @memberof OutputAnalyticsChannelHeatmapItem
     */
    percentage: number;
}

/**
 * Check if a given object implements the OutputAnalyticsChannelHeatmapItem interface.
 */
export function instanceOfOutputAnalyticsChannelHeatmapItem(value: object): boolean {
    if (!('band' in value)) return false;
    if (!('channel' in value)) return false;
    if (!('percentage' in value)) return false;
    return true;
}

export function OutputAnalyticsChannelHeatmapItemFromJSON(json: any): OutputAnalyticsChannelHeatmapItem {
    return OutputAnalyticsChannelHeatmapItemFromJSONTyped(json, false);
}

export function OutputAnalyticsChannelHeatmapItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): OutputAnalyticsChannelHeatmapItem {
    if (json == null) {
        return json;
    }
    return {
        
        'band': json['band'],
        'channel': json['channel'],
        'percentage': json['percentage'],
    };
}

export function OutputAnalyticsChannelHeatmapItemToJSON(value?: OutputAnalyticsChannelHeatmapItem | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'band': value['band'],
        'channel': value['channel'],
        'percentage': value['percentage'],
    };
}

